// Normalização de produtos -> item canônico de analytics.
//
// item canônico: { id, nome, preco, quantidade, categoria? }
// Os adapters traduzem para GA4 (item_id/item_name/price/quantity) e
// Pixel (id/quantity/item_price).
//
// Reaproveita getIdealInfoPrice (src/util/price.js) para extrair o preço unitário
// efetivo (priceBy) a partir do array `precos` do produto.
import { getIdealInfoPrice } from "../util/price";

export function mapProductsToItems(products = [], hasFidelidade = false) {
  return (products || [])
    .filter((p) => p && p.id != null)
    .map((p) => {
      const { priceBy } = getIdealInfoPrice(p.precos, hasFidelidade) || {};
      return {
        id: p.id,
        nome: p.nome,
        preco: Number(priceBy) || 0,
        quantidade: p.quantidade || 1,
        ...(p.categoria ? { categoria: p.categoria } : {}),
      };
    });
}

export function sumItemsValue(items = []) {
  return (items || []).reduce(
    (acc, it) => acc + (Number(it.preco) || 0) * (it.quantidade || 1),
    0
  );
}
